export default function Receipt() {
    // const logic = Logic();

    return (
        <div>
        </div>
    );
}